module.exports = __webpack_public_path__ + "static/media/colorTriad.1f52eb86.jpg";